import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import Price from "components/Price";
import Duration from "components/Duration";

const Row = styled.div`
  display: grid;
  grid-template-columns: 50% 25% 25%;
  margin-bottom: 0;
  padding: 1rem 0 0 0;

  ${({ theme }) => theme.mq.sm`
  grid-template-columns: 50% 25% 25%;
  `}
`;

const Service = styled.div`
  display: flex;
  font-size: 0.875rem;
  justify-content: flex-start;

  ${({ isDuration }) =>
    isDuration &&
    css`
      grid-row-start: 2;
      color: ${({ theme }) => theme.themeColors.darkGreen4};
      justify-content: flex-start;

      ${({ theme }) => theme.mq.sm`
        grid-column-start: 2;
        grid-row-start: 1;
        justify-content: flex-end;
      `}
    `}

  ${({ isPrice }) =>
    isPrice &&
    css`
      grid-column-start: 3;
      font-weight: 600;
      justify-content: flex-end;
    `}
`;

function ServicesTotal({ title, totalDuration, totalPrice }) {
  return (
    <Row>
      <Service>{title}</Service>
      {totalDuration ? (
        <Service isDuration>
          <Duration value={totalDuration} />
        </Service>
      ) : null}
      <Service isPrice>
        <Price value={totalPrice / 100} />
      </Service>
    </Row>
  );
}

ServicesTotal.propTypes = {
  title: PropTypes.string,
  totalDuration: PropTypes.number,
  totalPrice: PropTypes.number,
};

ServicesTotal.defaultProps = {
  title: "Total",
  totalDuration: null,
  totalPrice: null,
};

export default ServicesTotal;
